import { ReactNode } from "react";

import { AuthTokenContext } from "../context";
import { useAuthTokenProvider } from "../hooks/useAuthTokenProvider";

export const AuthTokenContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const authContext = useAuthTokenProvider();

  return (
    <AuthTokenContext.Provider value={authContext}>
      {children}
    </AuthTokenContext.Provider>
  );
};
